import { render, staticRenderFns } from "./BusinessFeatures.vue?vue&type=template&id=5db21376&scoped=true&"
import script from "./BusinessFeatures.vue?vue&type=script&lang=js&"
export * from "./BusinessFeatures.vue?vue&type=script&lang=js&"
import style0 from "./BusinessFeatures.vue?vue&type=style&index=0&id=5db21376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db21376",
  null
  
)

export default component.exports